import { render, staticRenderFns } from "./Servicii_programator_list.vue?vue&type=template&id=60cc877b&scoped=true"
import script from "./Servicii_programator_list.vue?vue&type=script&lang=js"
export * from "./Servicii_programator_list.vue?vue&type=script&lang=js"
import style0 from "./Servicii_programator_list.vue?vue&type=style&index=0&id=60cc877b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cc877b",
  null
  
)

export default component.exports